// extracted by mini-css-extract-plugin
export default {"modal":"modal__pOodi","content":"content__dMGnk","content__banner":"content__banner__dssi9"};